/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Include1_SubInputs */

const es_landing_price_include1_sub = /** @type {(inputs: Landing_Price_Include1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tramitación completa ante la autoridad marítima`)
};

const gl_landing_price_include1_sub = /** @type {(inputs: Landing_Price_Include1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tramitación completa ante a autoridade marítima`)
};

const en_landing_price_include1_sub = /** @type {(inputs: Landing_Price_Include1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full processing with the maritime authority`)
};

/**
* | output |
* | --- |
* | "Full processing with the maritime authority" |
*
* @param {Landing_Price_Include1_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_include1_sub = /** @type {((inputs?: Landing_Price_Include1_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Include1_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_include1_sub(inputs)
	if (locale === "en") return en_landing_price_include1_sub(inputs)
	return es_landing_price_include1_sub(inputs)
});